import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';		// map, tap, catchError, first

import { FireUserService } from "../../../modulo-comunes/servicios/fire-user-servicios";
import { DataUserService } from "../../../modulo-comunes/servicios/data-user-servicios";
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from '../../../modulo-comunes/servicios/data-empresa-servicios';

import { FuncionesService } from "../../../modulo-comunes/servicios/funciones-servicios";

@Component({
  selector: 'app-cambio-pwd',
  templateUrl: './cambio-pwd.component.html',
  styleUrls: ['./cambio-pwd.component.css']
})
export class CambioPwdComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  formCambioPwd = this.fb.group({
    //El usr va a ser un e-mail, no un texto cualquiera
    //fTxtUsr: ["", [Validators.required, Validators.minLength(5)]],
    fTxtMail: ["", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]{2,8}$")]]
  });
  modeloUsrAnt = {}; //para evitar que presionen Cotizar varias veces y se multiplique la misma cotización
  modeloUsrNue = {};
  //En este programa voy a usar la técnica del form, no la del modelo. Para no causar confusión, la fuente real de 
  //los datos del form va a ser formCambioPwd, pero voy a usar modeloLogin para guardar los datos como variables. 
  modeloLogin = {
    mail: '',
    mailReg: '',
    userYaCargado: this.dataUserService.userYaCargado,
    empresa: this.dataEmpresaService.empAut.nombre
  };
  mensajeLogin: string = '';
  mensajeLogin2: string = '';
  mensajeRegistro: string = '';
  mensajeRegistro2: string = '';
  mensajeLogout: string = '';
  mensajeLogout2: string = '';

  yaLogin = false;
  formOk = false;
  formError = false;
  formDuplic = false;
  srcLogo: string;
  sitio: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private fireUserService: FireUserService,
    private dataUserService: DataUserService,
    private funcionesService: FuncionesService,
    private muestraService:MuestraService,
    private logService : LogService,
    public dataEmpresaService: DataEmpresaService
  ) {
    this.logService.consoleLog('2', "PC CW userYaCargado: " + this.dataUserService.userYaCargado);
    this.logService.consoleLog('2', "PC CW user: " + this.dataUserService.user.nombre);
    this.logService.consoleLog('2', "PC CW userAut: " + this.dataUserService.userAut.nombre);
    if (this.dataUserService.userYaCargado) {
      this.mensajeLogout = 'Usuario actual: ' + this.dataUserService.user.email;
      this.mensajeLogout2 = 'Para cerrar la sesión o cambiar de usuario, presione Salir';
    }
  }

  ngOnInit() {
    this.sitio = this.dataEmpresaService.sitioElegido;
    if (this.sitio == 'EasyMed') {
      this.srcLogo = "assets/images/EMlogo2.svg";
    } else if (this.sitio == 'Efisys') {
      this.srcLogo = "assets/images/logo-efisys2.svg";
    }
    this.ocultaTopBar();
    this.ocultaFooter();
    this.modeloLogin.mail = '';   //"ortegalopez111@gmail.com";
    //this.loginSubmit();
  }

  ngOnDestroy(): void {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.muestraTopBar();
    this.muestraFooter();
    this.modeloLogin.mail = '';   //"ortegalopez111@gmail.com";
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public findInvalidControls(f: FormGroup): string[] {
    return this.funcionesService.findInvalidControls(f);
  }

  public chkValido(f: FormGroup, nombre: string): boolean {
    return this.funcionesService.chkValido(f, nombre);
  }

  public asignaEstiloBody(): object {
    let estBody: object = {};
    if (this.sitio == 'EasyMed') {
      estBody = { "background-image": "url('/assets/images/36918105_xl_1280x853.png')", "height":"100vh" };
    } else if (this.sitio == 'Efisys') {
      estBody = { "background-image": "url('/assets/images/tienda.png')", "height":"100vh" };
    }
    return estBody;
  }

  asignaEstiloLogo(): object {
    let estLogo: object = {};
    if (this.sitio == 'EasyMed') {
      estLogo = { };
    } else if (this.sitio == 'Efisys') {
      estLogo = { "height": "67px" };
    }
    return estLogo;
  }

  public asignaEstilo(f: FormGroup, nombre: string): object {
    return this.funcionesService.asignaEstilo(f, nombre);
  }

  public asignaEstiloSubmitDisabled(f: FormGroup): object {
    return this.funcionesService.asignaEstiloSubmitDisabled(f);
  }

  ocultaTopBar() {
    this.logService.consoleLog('2', "PC CW ocultaTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar w-nav/)
    ) {
      document.getElementById("navbar-1").className = "navbar-oculta";
    }
  }

  ocultaFooter() {
    this.logService.consoleLog('2', "PC CW ocultaFooter");
    //document.getElementById("boton").classList.toggle("active");
    if (
      document.getElementById("footer-1").className.match(/diag-wrapper/)
    ) {
      document.getElementById("footer-1").className = "footer-oculto";
    }
  }

  muestraTopBar() {
    this.logService.consoleLog('2', "PC CW muestraTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar-oculta/)
    ) {
      document.getElementById("navbar-1").className = "navbar w-nav";
    }
  }

  muestraFooter() {
    this.logService.consoleLog('2', "PC CW muestraFooter");
    if (
      document.getElementById("footer-1").className.match(/footer-oculto/)
    ) {
      document.getElementById("footer-1").className = "diag-wrapper";
    }
  }

  cambioPwdSubmit() {
    //esto es copiado del onSubmitCambioPwd, evita que se envíe el mismo form varias veces
    this.logService.consoleLog('2', "PC CW " + JSON.stringify(this.formCambioPwd.value));
    this.modeloLogin.mail = this.formCambioPwd.value.fTxtMail;

    this.modeloUsrNue = JSON.parse(JSON.stringify(this.formCambioPwd.value));
    if (this.funcionesService.deepEqual(this.modeloUsrNue, this.modeloUsrAnt)) {
      this.logService.consoleLog('2', "PC CW Ya se envió esta solicitud");
      this.formDuplic = true;
      setTimeout(() => {
        this.formDuplic = false;
      }, 5000);
    } else {
      this.logService.consoleLog('2', "PC CW Primer envío");
      this.logService.consoleLog('2', 'PC CW reset: ' + this.modeloLogin.mail);
      this.modeloUsrAnt = this.modeloUsrNue;
      this.fireUserService.afResetearPwd(this.modeloLogin.mail)
        .then(value => {
          this.logService.consoleLog('2', 'PC CW Cambio de contraseña solicitado para ' + this.modeloLogin.mail + ', val: ' + value);
          this.mensajeLogin = 'Le hemos enviado un mail';
          this.mensajeLogin2 = 'con un enlace para cambiar el password';
          this.muestraService.muestraMsgbox('CC-001: Cambio de contraseña', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'ThumbsUp')
            .pipe(take(1))
            .subscribe(r => {
              this.logService.consoleLog('2', 'PC CW Cambio de contraseña msgbox ' + r);
            });
        })
        .catch(err => {
          this.mensajeLogin = 'Problema al cambiar contraseña';
          this.logService.consoleLog('9', "PC CW Problema al cambiar contraseña");
          this.logService.consoleLog('9', "PC CW " + err.code);
          this.logService.consoleLog('9', "PC CW " + err.message);
          switch (err.code) {
            case 'auth/invalid-email':
              this.mensajeLogin2 = 'El e-mail no es válido, por favor revíselo.';
              break;
            case 'auth/user-disabled':
              this.mensajeLogin2 = 'El usuario está inhabilitado, por favor comuníquese con ' + this.modeloLogin.empresa;
              break;
            case 'auth/user-not-found':
              this.mensajeLogin2 = 'Este usuario no existe, quizás está mal digitado o aún no se ha registrado.';
              break;
            case 'auth/wrong-password':
              this.mensajeLogin2 = 'La contraseña es incorrecta, por favor digítela nuevamente.';
              break;
            case "auth/network-request-failed":
              this.mensajeLogin2 = 'Error de red: timeout, no se puede contactar el host, no hay Internet, etc.';
              break;
            default:
              this.mensajeLogin2 = err.message;
              break;
          }
          this.muestraService.muestraMsgbox('CC-002: Error en cambio de contraseña!', this.mensajeLogin, this.mensajeLogin2, 'Salir', 'Error')
            .pipe(take(1))
            .subscribe(r => {
              this.logService.consoleLog('2', 'PC CW Error en cambio de contraseña msgbox ' + r);
            });
        });
    }
  }
}
